<template>
    <div class="form">
        <Spin fix v-if="loading"></Spin>
        <Form
            ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100"
            :viewonly="isView"
        >
            <form-item label="维修情况反馈" prop="feedBack">
                <Input type="textarea" :rows="3" v-model="info.feedBack" />
            </form-item>

            <form-item label="附件上传" prop="attachments">
                <preview-upload
                    v-model="info.attachments"
                    multiple
                    :format="imgSuffix"
                    :maxNumber="5"
                />
            </form-item>
            <!-- <form-item label="是否使用配件" prop="havaFitting">
                <RadioGroup v-model="info.havaFitting">
                    <Radio :label="1">是</Radio>
                    <Radio :label="0">否</Radio>
                </RadioGroup>
            </form-item>
            <form-item label="配件名称" prop="fittingName">
                <Input v-model="info.fittingName" placeholder="配件名称" />
            </form-item> -->
            <form-item label="反馈人" prop="feedBackUser">
                <Input v-model="info.feedBackUser" disabled />
            </form-item>
        </Form>
    </div>
</template>
<script>
import {
    repairAddFee,
    repairFeedBack,
    repairView,
    repairViewFeedBack,
} from '@/api/repair'
import FeeField from '_v/daily/repair-fee-field'
import { currency } from '_u/helper'
import config from '@/config'

export default {
    name: 'repairAddForm',
    components: { FeeField },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            info: {
                id: '', // 数据编号
                feedBack: '', //反馈内容
                // havaFitting: '1', //是否使用配件
                // fittingName: '', //配件名称
                feedBackUser: '', //反馈人
                attachments: '', //附件
            },
            feeList: [], //维修费用列表
            dict: {
                repairFeeType: this.$dict.NULL,
            },
            imgSuffix: config.upload.imgSuffix,
        }
    },

    computed: {
        ruleValidate() {
            return {
                feedBack: [
                    {
                        required: true,
                        message: '原因必填',
                    },
                ],
                // fittingName: [
                //     {
                //         validator: (rule, value, callback, source, options) => {
                //             const { havaFitting } = source
                //             if (havaFitting === '1') {
                //                 if (!value) {
                //                     callback(new Error('配件名称必填'))
                //                 }
                //             }
                //             callback()
                //         },
                //         message: '必填',
                //     },
                // ],
            }
        },
        user() {
            return this.$store.state.user.info
        },
        isView() {
            return !!this.info.id
        },
    },
    methods: {
        fetch() {
            this.loading = true
            return Promise.all([repairViewFeedBack(this.id)]).then((r) => {
                const [view] = r
                if (view.data.entity) {
                    this.info = view.data.entity
                    // this.info.havaFitting = this.info.havaFitting.toString()
                    this.initBtns()
                }
            })
        },
        initBtns() {
            // 按钮配置
            const btns = []
            if (this.isView) {
                btns.unshift({
                    type: 'default',
                    name: 'cancel',
                    text: '关闭',
                })
            } else {
                btns.unshift({
                    type: 'default',
                    name: 'cancel',
                    text: '取消',
                })
                btns.unshift({
                    type: 'primary',
                    name: 'confirm',
                    text: '确定',
                })
            }
            this.$modal.updateBtns(btns)
        },
    },

    mounted() {
        this.info.feedBackUser = this.user.nickName
        var $info = this.$refs.info

        // 预加载
        this.$modal.beforeEnter((next) => {
            this.loading = true
            this.fetch()
                .then((r) => {
                    next()
                })
                .finally((_) => {
                    this.loading = false
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            if (!this.loading) {
                $info
                    .validate()
                    .then(() => {
                        const info = this.$refs.info.populateData()
                        info.repairId = this.id
                        return repairFeedBack(info)
                        // options.closeModal = false
                        // return Promise.resolve()
                    })
                    .then((res) => {
                        this.$Message.success('保存成功')
                    })
                    .catch((err) => {
                        options.closeModal = false
                    })
                    .finally(() => {
                        next()
                    })
            }
        })
    },
}
</script>
<style lang="less" scoped></style>
